import {Card, Flag, openDialog, Separator} from 'platform/components';
import {HStack, Space, Text} from 'platform/foundation';

import {SeriesResponseBody} from '@dms/api/core';
import {RentalSettingsResponseBody} from '@dms/api/rental';
import i18n from '@dms/i18n';
import {EMPTY_PLACEHOLDER} from '@dms/shared';

import {getSafely} from 'shared/web';

import {PutDefinitionForm} from './PutDefinitionForm';

interface TenantSeriesCardProps {
  rentalSettings: RentalSettingsResponseBody[];
  seriesById: Record<string, SeriesResponseBody>;
}

export function TenantSeriesCard(props: TenantSeriesCardProps) {
  const defaultSettings = props.rentalSettings?.find((settings) => settings.branchId === null);

  return (
    <Card
      variant="inlineGrey"
      title={i18n.t('entity.rental.labels.generalSettings')}
      parameters={[i18n.t('entity.rental.labels.generalSettingsDescription')]}
      actions={[
        {
          type: 'button',
          title: i18n.t('general.actions.edit'),
          leftIcon: 'image/edit',
          variant: 'link',
          onClick: () =>
            openDialog(<PutDefinitionForm settingsId={defaultSettings?.rentalSettingsId} />, {
              title: i18n.t('entity.rental.labels.editTenantDefinition'),
            }),
        },
      ]}
    >
      <Separator spacing={0} />
      <Space vertical={2} />

      <HStack justify="space-between" align="center">
        <HStack spacing={2} align="baseline">
          <Text color="tertiary" size="small">
            {i18n.t('entity.rental.labels.selectedSeries')}:
          </Text>
          <Flag
            label={
              defaultSettings?.orderSeriesId
                ? (getSafely(props.seriesById, defaultSettings?.orderSeriesId)?.name ??
                  defaultSettings?.orderSeriesId)
                : EMPTY_PLACEHOLDER
            }
            colorScheme="teal"
          />
        </HStack>
      </HStack>
    </Card>
  );
}
